module.exports = __webpack_public_path__ + "static/media/hydroponics_shop_nft1.a0b62079.webp";